import { useState } from "react";
import { Container } from "react-bootstrap";
import CookableItemsTab from "./CookableItemsTab";
import ChefsTab from "./ChefsTab";
import ProductionProductsTab from "./ProductionProductsTab";
import OrdersTab from "./OrdersTab";
import ProductionSheetTab from "./ProductionSheetTab";
import AdminTrackerTab from "./AdminTrackerTab";

const TABS = [
  { key: "cookable", label: "Cookable Items" },
  { key: "chefs", label: "Chefs" },
  { key: "products", label: "Products" },
  { key: "orders", label: "Orders" },
  { key: "production", label: "Production" },
  { key: "tracker", label: "Admin Tracker" },
];

export default function ProductionManagement() {
  const [activeTab, setActiveTab] = useState("cookable");
  const [session, setSession] = useState("b");

  return (
    <div>
      {/* Top tab bar */}
      <div style={{
        background: "#fff", borderBottom: "2px solid #EEECEA",
        overflowX: "auto", marginBottom: 0,
      }}>
        <div style={{ display: "flex", padding: "0 1.5rem" }}>
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                padding: "14px 20px",
                border: "none",
                borderBottom: activeTab === tab.key ? "3px solid #1D9E75" : "3px solid transparent",
                fontWeight: 500,
                fontSize: 14,
                cursor: "pointer",
                background: "transparent",
                color: activeTab === tab.key ? "#1D9E75" : "#888",
                whiteSpace: "nowrap",
                transition: "all 0.15s",
                marginBottom: -2,
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <Container fluid style={{ maxWidth: 1400, padding: "1.5rem" }}>
        {activeTab === "cookable" && <CookableItemsTab />}
        {activeTab === "chefs" && <ChefsTab />}
        {activeTab === "products" && <ProductionProductsTab />}
        {activeTab === "orders" && (
          <OrdersTab session={session} onSessionChange={setSession} />
        )}
        {activeTab === "production" && (
          <ProductionSheetTab session={session} onSessionChange={setSession} />
        )}
        {activeTab === "tracker" && <AdminTrackerTab />}
      </Container>
    </div>
  );
}
